import { EnvironmentConfig } from "@me8eon/config";
import { translateKey } from "../../../../util/translate";

export type ReportData = {
    "device.number_of_system_crashes_7d": number,
    "Number_of_edge_crashes": string,
    "remote_action.get_zscaler_status_windows.execution.outputs.Running": string,
    "Number_of_chrome_crashes": string,
    "sytem_drive_free_space": number,
    "device.boot.days_since_last_full_boot": number,
    "Number_of_teams_crashes": string,
    "remote_action.get_outlook_storage_info_windows.execution.outputs.OSTThresholdExceeded": string,
    "Teams_plugi_is_disabled": string,
    "remote_action.get_zscaler_status_windows.execution.outputs.ZPA_state": string,
    "device.operating_system.days_since_last_update": number
}

export type ActionBenchMark = {
    recommendedAction: string;
    recommendedActionName: string;
    benchMark: number | string[];
    category: string;
    comparator: string;
    reportMessage: string;
    nexthinkAction: boolean;
    actionInfo?: string;
}

export type NexthinkHealthCheckBenchMark = Record<keyof ReportData, ActionBenchMark>

export const nexthinkHealthCheckBenchmarks: NexthinkHealthCheckBenchMark = {
    "device.number_of_system_crashes_7d": {
        "recommendedAction": "only information",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.systemCrashes.action",
        "benchMark": 2,
        "category": "Device Reliability",
        "comparator": "greater",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.systemCrashes.message",
        "nexthinkAction": false,
    },
    "Number_of_edge_crashes": {
        "recommendedAction": "#clear_microsoft_edge_settings_gsd",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.edgeCrashes.action",
        "benchMark": 2,
        "category": "Application Reliability",
        "comparator": "greater",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.edgeCrashes.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.edgeCrashes.actionInfo",
        "nexthinkAction": true
    },
    "remote_action.get_zscaler_status_windows.execution.outputs.Running": {
        "recommendedAction": "",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.ZScalarStatus.action",
        "benchMark": 0,
        "category": "Network Reliability",
        "comparator": "equals",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.ZScalarStatus.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.ZScalarStatus.actionInfo",
        "nexthinkAction": true
    },
    "Number_of_chrome_crashes": {
        "recommendedAction": "#clear_chrome_cache",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.chromeCrashes.action",
        "benchMark": 2,
        "category": "Application Reliability",
        "comparator": "greater",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.chromeCrashes.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.chromeCrashes.actionInfo",
        "nexthinkAction": true
    },
    "sytem_drive_free_space": {
        "recommendedAction": "#disk_cleanup_deep",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.driveFreeSpace.action",
        "benchMark": EnvironmentConfig.isHigherEnv ? 24696061953 : 200000000000,
        "category": "Device Performance",
        "comparator": "lesser",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.driveFreeSpace.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.driveFreeSpace.actionInfo",
        "nexthinkAction": true
    },
    "device.boot.days_since_last_full_boot": {
        "recommendedAction": "only information",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.daysSinceFullBoot.action",
        "benchMark": 7,
        "category": "Device Performance",
        "comparator": "greater",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.daysSinceFullBoot.message",
        "nexthinkAction": false,
    },
    "Number_of_teams_crashes": {
        "recommendedAction": "#clear_microsoft_teams_work_or_school_cache_no_campaign",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.teamsCrashes.action",
        "benchMark": 2,
        "category": "Application Performance",
        "comparator": "greater",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.teamsCrashes.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.teamsCrashes.actionInfo",
        "nexthinkAction": true
    },
    "remote_action.get_outlook_storage_info_windows.execution.outputs.OSTThresholdExceeded": {
        "recommendedAction": "repair_outlook_ost_problem_windows",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.outlookOstStatus.action",
        "benchMark": 1,
        "category": "Application Reliability",
        "comparator": "equals",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.outlookOstStatus.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.outlookOstStatus.actionInfo",
        "nexthinkAction": true
    },
    "Teams_plugi_is_disabled": {
        "recommendedAction": "",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.teamsPluginDisabled.action",
        "benchMark": 1,
        "category": "Application Reliability",
        "comparator": "equals",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.teamsPluginDisabled.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.teamsPluginDisabled.actionInfo",
        "nexthinkAction": true
    },
    "remote_action.get_zscaler_status_windows.execution.outputs.ZPA_state": {
        "recommendedAction": "",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.ZScalarState.action",
        "benchMark": ["CONNECTING","TUNNEL_FORWARDING","ON"],
        "category": "Network Reliability",
        "comparator": "Include",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.ZScalarState.message",
        "actionInfo": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.ZScalarState.actionInfo",
        "nexthinkAction": true,
    },
    "device.operating_system.days_since_last_update": {
        "recommendedAction": "only information",
        "recommendedActionName": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.daysSinceLastUpdate.action",
        "benchMark": 29,
        "category": "Device Reliability",
        "comparator": "greater",
        "reportMessage": "chatBot.nexthinkIntegration.smartSolution.reportAndAction.daysSinceLastUpdate.message",
        "nexthinkAction": false,
    }
}

const zpaStateKey = "remote_action.get_zscaler_status_windows.execution.outputs.ZPA_state";

export type ReportParams = {
    name: string;
    value: string;
}

export type ReportCategory = {
    name: string;
    actionNeeded: boolean;
    parameters: ReportParams[];
};

export type RecommendedAction = {
    id: string;
    name: string;
    info?: string;
}

const defaultActions = [
  { id: "#clear_microsoft_edge_settings_gsd", name: "chatBot.nexthinkIntegration.smartSolution.reportAndAction.edgeCrashes.action", info: "chatBot.nexthinkIntegration.smartSolution.reportAndAction.edgeCrashes.actionInfo" },
  { id: "#disk_cleanup_deep", name: "chatBot.nexthinkIntegration.smartSolution.reportAndAction.driveFreeSpace.action", info: "chatBot.nexthinkIntegration.smartSolution.reportAndAction.driveFreeSpace.actionInfo" },
  { id: "repair_outlook_ost_problem_windows", name: "chatBot.nexthinkIntegration.smartSolution.reportAndAction.outlookOstStatus.action", info: "chatBot.nexthinkIntegration.smartSolution.reportAndAction.outlookOstStatus.actionInfo" }
];

export const reportAndRecommendedActions = (reportdata: ReportData | null) => {
    if(!reportdata) return { report: [], recommendedActions: [], recommendedFixes: [] };
    const categoryReport: string[] = [];
    const recommendedActions: RecommendedAction[] = [];
    const recommendedFixes: string[] = [];

    for (let [key, value] of Object.entries(reportdata)) {
        if (key !== zpaStateKey) {
            value = Number(value);
        }
        const benchmark = nexthinkHealthCheckBenchmarks[key as keyof NexthinkHealthCheckBenchMark];
        if (benchmark && benchmark.recommendedAction) {
            const actionNeeded = checkIfActionNeeded(value, benchmark.benchMark, benchmark.comparator);
            if (actionNeeded) {
                const reportMessage = translateKey(benchmark.reportMessage).replace("<n>", key === 'sytem_drive_free_space' ? (Number(value) / 1000000000).toFixed(2) : String(value));
                categoryReport.push(reportMessage);
                if (benchmark.nexthinkAction) {
                    recommendedActions.push({
                        id: benchmark.recommendedAction,
                        name: benchmark.recommendedActionName,
                        info: benchmark.actionInfo ?? ""
                    });
                }

                if (!benchmark.nexthinkAction) {
                    recommendedFixes.push(benchmark?.recommendedActionName || "");
                }
            }
        }
    }
    return {report: categoryReport, recommendedActions, recommendedFixes};
}

function checkIfActionNeeded(value: string | number, benchMark: number | string[], comparator: string) {
    if (Array.isArray(benchMark)) {
        if (typeof value === "string") {
            if (comparator === "NotInclude") {
                return benchMark.includes(value);
            }
            if (comparator === "Include") {
                return !benchMark.includes(value);
            }
        }
        return false;
    } else {
        if (typeof value === "number") {
            if (comparator === "greater") {
                return value > benchMark;
            }
            if (comparator === "lesser") {
                return value < benchMark;
            }
            if (comparator === "equals") {
                return value === benchMark;
            }
        }
        return false;
    }
}
